module.exports = __webpack_public_path__ + "img/checkout-responsive.17b706a0.svg";